<template>
    <div class="box">
        
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <div  style="display: flex;align-items: center">
                <span class="el-icon-back" style="font-size: 30px;margin-right: 15px;cursor:pointer" @click="handleBack"></span>
                <el-breadcrumb-item>应用版本管理</el-breadcrumb-item>
            </div>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true"  class="user-search" style="text-align: left;padding-top: 20px">
            <el-form-item label="" prop="SearchKey">
                <el-input  placeholder="请输入关键词" v-model="model.SearchKey"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button  type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button  type="primary" icon="el-icon-plus" @click="handleAdd()">添加</el-button>
            </el-form-item>
        </el-form>
        <!-- 列表 -->
        <el-table border default-expand-all :data="dataList" style="width: 100%"  @selection-change="selectChange" highlight-current-row
            :default-sort="{prop: 'date', order: 'descending'}">
            <el-table-column align="center" type="selection" width="50">
            </el-table-column>
            <el-table-column prop="AppID" label="ID" sortable width="180">
            </el-table-column>
            <el-table-column prop="AppVersion" label="应用版本" sortable width="180">
            </el-table-column>
            <el-table-column prop="AppUrl" label="应用路径" sortable width="180">
            </el-table-column>
            <el-table-column prop="AppUpdateLog" label="更新说明" sortable width="180">
            </el-table-column>
            <el-table-column prop="ReleaseNote" label="应用版本说明" sortable width="180">
            </el-table-column>
            <el-table-column prop="AppDownLoadUrl" label="应用安装包地址" sortable width="180">
            </el-table-column>
            <el-table-column label="操作" min-width="300" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                </template>
        </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row style="text-align: left;padding-top: 10px">
            <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page="model.Page"
                layout="total,prev, pager, next, jumper"
                :total="listCount"
                :page-size="model.Rows">
            </el-pagination>
        </el-row>
        <add v-if="isShowAdd" :dialogFormVisible="isShowAdd" @closeAddDialog="handleCloseAdd" :AppID="this.model.AppID" :AppType="this.AppType"></add>
        <edit v-if="isShowEdit" :dialogFormVisible="isShowEdit" @closeEditDialog="handleCloseEdit" :data="editData" :AppType="this.AppType"></edit>
    </div>
</template>

<script>
    import {GetAppLogList,DeleteAppLog} from '../../../api/app'
    import add from './add'
    import edit from './edit'
    export default {
        components: {
            add,
            edit
        },
        data() {
            return {
                isShowAdd: false,
                isShowEdit: false,
                listCount: null,
                dataList: [],
                editData: [],
                model: {
                    Page: 1,
                    Rows: 10,
                    SearchKey: '',
                    AppID: null
                },
            }
        },
        watch: {
            'model.SearchKey': {
                handler(newVal,oldVal) {
                    if(newVal === '') {
                        this.model.SearchKey = '';
                        this.GetAppLogList();
                    }
                }
            }
        },
        props: {
            AppType: {
                required: true,
            },
            id: {
                required: true
            }
        },
        mounted() {
            this.model.AppID = this.id;
            // this.AppType = this.$route.query.AppType;
            this.GetAppLogList();
        },
        methods: {
            GetAppLogList() {
                GetAppLogList(this.model).then(data=>{
                    if(!data.iserror) {
                        this.dataList = data.data.List;
                        this.listCount = data.data.Count;
                    }
                })
            },
            handleCurrentChange(val) {
                this.model.Page = val;
                this.GetAppLogList();
            },
            selectChange(val) {
                this.selectdata = val
            },
            handleSearch() {
                if(this.model.SearchKey === '') {
                    this.$message({
                        message: '搜索内容不能为空',
                        type: 'warning'
                    });
                    return false;
                }
                this.model.Page = 1;
                this.GetAppLogList();
            },
            handleAdd() {
                this.isShowAdd = true;
            },
            handleEdit(row) {
                this.editData = row;
                this.isShowEdit = true;
            },
            handleCloseAdd() {
                this.isShowAdd = false;
                this.GetAppLogList();
            },
            handleCloseEdit() {
                this.isShowEdit = false;
                this.GetAppLogList();
            },
            handleDelete(row) {
                let id = row.OID;
                this.$confirm('确认要删除该配置项吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    this.DeleteAppLog(id);
                })
            },
            DeleteAppLog(id) {
                DeleteAppLog({OID: id}).then(data=>{
                    if(!data.iserror) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.GetAppLogList();
                    }
                })
            },
            handleBack() {
                // this.$router.go(-1)
                this.$emit('closeVersionManage')
            }
        }
    }
</script>

<style>

</style>